<template>
  <div class="container-fluid header">
    <div class="row justify-content-center">
      <div class="col-12 col-md-12">      
        <a href="https://www.elnuevodia.com/" target="_blank">
          <img class="brand-logo" src="@/assets/main-logo.png" alt="image" />
        </a>
        <div class="lang-bar">
          <RouterLink class="btn idioma" :to="{ name: 'list', params: { locale: `en` }}">EN</RouterLink>
          <RouterLink class="btn idioma" :to="{ name: 'list', params: { locale: `es` }}">ES</RouterLink>
        </div>
      </div>
    </div>
  </div>
</template>

<script>


export default {
  name: 'NavBar'
}
</script>
